import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

class PriceGuidePaginationButton extends React.Component {
  static propTypes = {
    links: PropTypes.object.isRequired,
    link: PropTypes.string.isRequired,
    followPagination: PropTypes.func.isRequired,
    direction: PropTypes.string.isRequired,
  };

  render() {
    if (this.props.links && this.props.links[this.props.link]) {
      return (
        <button className={classNames('button button--mini button--offwhite', this.props.link)} onClick={this.props.followPagination(this.props.links[this.props.link].href)}>
          <span className={`fa fa-chevron-${this.props.direction}`} />
        </button>
      );
    }
    return (
      <button className={classNames('button button--mini button--offwhite ml-half', this.props.link)} disabled="disabled">
        <span className={`fa fa-chevron-${this.props.direction}`} />
      </button>
    );
  }
}

export default PriceGuidePaginationButton;
